// Singleton authenticated Socket.io connection used by Collab (rooms +
// stroke relay) and as the side-effect that registers the user as
// "present" on the server. See Features.md F-19.

import { io } from "socket.io-client";
import Parse from "parse";

let socket = null;

export function getSocket() {
  if (socket) return socket;

  const base = process.env.VUE_APP_API.replace(/\/api$/, "");
  const token = Parse.User.current() && Parse.User.current().getSessionToken();
  socket = io(base, {
    auth: { token },
    autoConnect: true,
    reconnection: true,
    // Server forces polling-only transport to avoid colliding with Parse
    // Live Query's WS upgrade handler — see server/index.js comment.
    transports: ["polling"],
  });
  socket.on("connect", () => console.log("[socket] connected", socket.id));
  socket.on("connect_error", (err) =>
    console.warn("[socket] connect_error:", err && err.message)
  );
  socket.on("disconnect", (reason) =>
    console.log("[socket] disconnected:", reason)
  );
  return socket;
}

export function teardownSocket() {
  if (!socket) return;
  socket.disconnect();
  socket = null;
}
